var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[(_vm.$route.meta.showHeaderOnFirstPage && !('page' in _vm.$route.query))?_c('FrontHero'):_vm._e(),_c('NavPaginatedSongList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }